import * as React from "react";
import { imgSrc } from "src/components/PlmUploader/imgSrc";
import styles from "./Cell2ReadonlyText.module.less";

type PropsCell2ReadonlyText = {
  isImage?: boolean;
  children?: React.ReactNode;
};

export const Cell2ReadonlyText: React.FC<PropsCell2ReadonlyText> = ({
  isImage,
  children,
}) => {
  const content =
    isImage && typeof children === "string" ? (
      <img src={imgSrc(children, "small")} alt="" />
    ) : (
      children
    );
  return <div className={styles.box}>{content}</div>;
};
